import React from "react";
import DonationForm from "../components/DonationForm";

const Donate: React.FC = () => {
  return (
    <>
      {/* Hero Banner */}
      <section className="relative bg-gray-900 py-16">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary opacity-80"></div>
        </div>
        <div className="relative container-custom text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Make a Donation
          </h1>
          <p className="text-white/90 text-lg max-w-3xl mx-auto">
            Your contribution helps us continue our work in empowering
            communities and creating positive change.
          </p>
        </div>
      </section>

      {/* Donation Form Section */}
      <section className="py-16 bg-light">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto">
            <DonationForm />
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-dark mb-4">
              Your Donation Makes a Difference
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Here's how your contributions help us create real impact in
              communities across the country.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="bg-primary/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-primary">₹500</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Basic Support</h3>
              <p className="text-gray-600">
                Provides educational materials for 5 children or basic hygiene
                supplies for a family.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="bg-primary/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-primary">₹2000</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Community Impact</h3>
              <p className="text-gray-600">
                Covers a skill development workshop for women or health checkups
                for 10 individuals.
              </p>
            </div>

            <div className="text-center p-6">
              <div className="bg-primary/10 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-primary">₹5000</span>
              </div>
              <h3 className="text-xl font-semibold mb-2">Lasting Change</h3>
              <p className="text-gray-600">
                Helps build sanitation facilities in a village or supports a
                community clean water project.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Tax Benefits Section */}
      <section className="py-16 bg-light">
        <div className="container-custom">
          <div className="bg-white p-8 rounded-lg shadow-md">
            <h3 className="text-2xl font-bold text-dark mb-4">
              Tax Benefits for Your Donation
            </h3>
            <p className="text-gray-600 mb-4">
              All donations to Lifeline Foundation NGO are eligible for tax
              deductions under Section 80G of the Income Tax Act. You will
              receive a donation receipt that can be used for claiming tax
              benefits.
            </p>
            <div className="bg-light p-4 rounded border border-gray-200">
              <p className="text-sm text-gray-600">
                <strong>Note:</strong> For specific questions about tax benefits
                or to request additional documentation, please email us at
                donations@lifelinefoundation.org or call us at +91 123-456-7890.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Donate;
